<template>
  <div>
    <h2 class="is-size-3">Material portal</h2>
    <b-columns is-multiline>
      <b-column class="is-full">
        <b-field>
          <b-input
            v-model="filter"
            type="text"
            icon="search"
            placeholder="Search"
          />
        </b-field>
      </b-column>
      <b-column>
        <category-list />
      </b-column>
    </b-columns>
  </div>
</template>

<script>
import CategoryList from '@/components/material/CategoryList'
import { mapActions } from 'vuex'

export default {
  components: {
    CategoryList
  },
  data () {
    return {
      filter: ''
    }
  },
  created () {
    this.fetchResources()
  },
  methods: {
    ...mapActions(['fetchResources']),
  }
}
</script>
